import styled from "styled-components";
import { Card, Table, Button, Modal } from "react-bootstrap";

export const StyledCard = styled(Card)`
  margin: 20px;
`;

export const LinkStyled = styled.a`
  cursor: pointer;
  font-weight: 500;
  display: inline-block;

  &&,
  &&:focus,
  &&:active,
  &&:visited {
    color: #ff6136;
    text-decoration: none;
  }

  &&:hover {
    color: #ff6136;
    text-decoration: underline;
  }
`;

export const ButtonContainer = styled.div`
  display: flex;
  gap: 1rem;
  margin-top: 2rem;
`;

export const SectionTitle = styled.h4`
  margin-top: 2rem;
  margin-bottom: 1rem;
  font-weight: 600;
`;

export const WitLabel = styled.label`
  display: block;
  width: 100%;
  padding: 0;
  margin: 30px 0 20px 0;
  font-size: 21px;
  line-height: inherit;
  color: #3a3f51;
  border: 0;
  border-bottom: 1px solid #e5e5e5;
`;

export const StyledTable = styled(Table)`
  margin-top: 1rem;
`;

export const ActionButton = styled(Button)`
  margin-right: 0.5rem;

  &.btn-danger {
    i {
      color: white;
    }
  }
`;

export const StyledModalBody = styled(Modal.Body)`
  max-height: 70vh;
  overflow-y: auto;
`;

export const TableScrollWrapper = styled.div`
  overflow-x: auto;
  max-width: 100%;
`;

export const StickyTh = styled.th`
  position: sticky;
  right: 0;
  background: #fff;
  z-index: 2;
  &::after {
    content: "";
    position: absolute;
    left: 0;
    top: 0;
    bottom: 0;
    width: 1px;
    background: #dee2e6;
  }
`;

export const StickyTd = styled.td`
  position: sticky;
  right: 0;
  background: #fff;
  z-index: 1;
  white-space: nowrap;
  &::after {
    content: "";
    position: absolute;
    left: 0;
    top: 0;
    bottom: 0;
    width: 1px;
    background: #dee2e6;
  }
`;
